import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import isEqual from 'lodash/isEqual';

export interface LogPanelCta {
  label: string;
  url: string;
}

export interface SourceChunksPanelContent {
  sourceName: string;
  chunks: string[];
}

export type LogPanelView = 'json' | 'sourceChunks';

export interface LogPanelData {
  content: any;
  title?: string;
  description?: string;
  view?: LogPanelView;
  cta?: LogPanelCta;
}

export interface LogPanelState {
  isLogPanelOpen: boolean;
  panelData: LogPanelData | null;
}

const initialState: LogPanelState = {
  isLogPanelOpen: false,
  panelData: null,
};

const LogPanelSlice = createSlice({
  name: 'LogPanel',
  initialState,
  reducers: {
    openLogPanel: (state, action: PayloadAction<LogPanelData>) => {
      state.isLogPanelOpen = true;
      state.panelData = action.payload;
    },
    closeLogPanel: state => {
      state.isLogPanelOpen = false;
      state.panelData = null;
    },
    toggleLogPanel: state => {
      state.isLogPanelOpen = !state.isLogPanelOpen;
      if (!state.isLogPanelOpen) {
        state.panelData = null;
      }
    },
    toggleLogPanelWithData: (state, action: PayloadAction<LogPanelData>) => {
      if (state.isLogPanelOpen && isEqual(state.panelData, action.payload)) {
        state.isLogPanelOpen = false;
        state.panelData = null;
        return;
      }

      state.isLogPanelOpen = true;
      state.panelData = action.payload;
    },
  },
});

export const {
  openLogPanel,
  closeLogPanel,
  toggleLogPanel,
  toggleLogPanelWithData,
} = LogPanelSlice.actions;

export default LogPanelSlice.reducer;
